import { useEffect } from "react";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function absUrl(url) {
  if (!url) return url;
  if (url.startsWith("http")) return url;
  if (url.startsWith("/")) return window.location.origin + url;
  return url;
}

export function Seo({ title, description, image, type = "website", jsonLd = null }) {
  useEffect(() => {
    const prevTitle = document.title;
    const img = absUrl(image);
    const url = window.location.href;

    if (title) document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:site_name", "DNA eCommerce Ads");
    upsertMeta("property", "og:image", img);
    upsertMeta("name", "twitter:card", img ? "summary_large_image" : "summary");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", img);

    // canonical
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url.split("?")[0]);

    // JSON-LD structured data
    let script = document.getElementById("ld-json");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "ld-json";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }

    return () => {
      document.title = prevTitle;
      const s = document.getElementById("ld-json");
      if (s) s.remove();
    };
  }, [title, description, image, type, jsonLd]);

  return null;
}
